import choVayConst from "constants/choVayConst";
import { LaiSuatText2 } from "constants/choVayConst";
import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const LichSuGiaHanKy = ({ listLichSuTaiSan }) => {
  const listItem = () => {
    return (
      listLichSuTaiSan != null &&
      listLichSuTaiSan.map((item, index) => {
        return (
          <tr className="active">
            <td>{item.IndexId}</td>
            <td>{item.Code}</td>
            <td>{item.Time}</td>
            <td>{item.Note}</td>
          </tr>
        );
      })
    );
  };

  return (
    <>
      <div className="table-responsive table-2">
        <table className="table table-bordered mb-0">
          <thead>
            <tr>
              <th>STT</th>
              <th>Mã tài sản</th>
              <th>Thời gian</th>
              <th>Ghi chú</th>
            </tr>
          </thead>
          <tbody>{listItem()}</tbody>
        </table>
      </div>
    </>
  );
};
